import React from 'react';

const ProgressModal = ({ progressModal }) => {
  if (!progressModal.visible) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white dark:bg-gray-800 rounded-2xl p-8 max-w-md mx-4 shadow-2xl">
        <div className="text-center">
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-6">
            {progressModal.operation}
          </h2>
          
          <div className="relative inline-flex items-center justify-center mb-4">
            <svg className="w-20 h-20 transform -rotate-90" viewBox="0 0 100 100">
              <circle
                cx="50"
                cy="50"
                r="40"
                stroke="currentColor"
                strokeWidth="8"
                fill="transparent"
                className="text-gray-200 dark:text-gray-700"
              />
              <circle
                cx="50"
                cy="50"
                r="40"
                stroke="currentColor"
                strokeWidth="8"
                fill="transparent"
                className="text-red-500"
                strokeLinecap="round"
                strokeDasharray={`${2 * Math.PI * 40}`}
                strokeDashoffset={`${2 * Math.PI * 40 * (1 - (progressModal.progress / progressModal.total))}`}
                style={{
                  transition: 'stroke-dashoffset 0.3s ease-in-out',
                }}
              />
            </svg>
            <div className="absolute inset-0 flex items-center justify-center">
              <span className="text-lg font-semibold text-gray-900 dark:text-white">
                {Math.round((progressModal.progress / progressModal.total) * 100)}%
              </span>
            </div>
          </div>
          
          <p className="text-gray-600 dark:text-gray-400 text-sm">
            {progressModal.progress} of {progressModal.total} chats processed
          </p>
        </div>
      </div>
    </div>
  );
};

export default ProgressModal;